export const IM_DFM_URL_PARAM = 'imDfmFeedback'

export const MANUFACTURABILITY_FEEDBACK_TAB = 'feedback'
export const QUOTE_TAB = 'quote'
